export function showLoaderUrl(url: string) {
  const loader = document.querySelector(".ole-loader") as HTMLElement;
  const loaderImg = loader.querySelector("img") as HTMLImageElement;
  loaderImg.src = url;
}

export function showLogoLoader(show: boolean) {
  const loader = document.querySelector(".ole-loader") as HTMLElement;
  if (show) {
    loader.style.opacity = "1";
  } else {
    loader.style.opacity = "0";
  }
}

export function initInfo() {
  const canvasInfo = document.querySelector(".canvas-info") as HTMLElement;
  canvasInfo.style.opacity = "1";
  document.querySelector("#ole-canvas")?.addEventListener("wheel", () => {
    canvasInfo.style.opacity = "0";
  });
  document.querySelector("#ole-canvas")?.addEventListener("touchstart", () => {
    canvasInfo.style.opacity = "0";
  });
  document.querySelector("#ole-canvas")?.addEventListener("mousedown", () => {
    canvasInfo.style.opacity = "0";
  });
  if (window.parent) {
    window.parent.postMessage({ state: "loaded" }, "*");
  }
}
